// extracted by mini-css-extract-plugin
export default {"root":"ChatMessages_root__pU4N3","date":"ChatMessages_date__rpmE1"};